<template>
  <div class="locale-selector">
    <Transition name="fade">
      <div v-if="active" class="locale-backdrop" @click="backdropOnClick" />
    </Transition>
    <div ref="localeBtn" :class="isActive" :disabled="disabled" class="locale-btn"
         @click="dropdownOnClick"
    >
      <span class="icon icon-map material-icons">
        place
      </span>
      <span class="label">
        {{ currentLocaleName }}
      </span>
      <span class="icon icon-drop material-icons">
        arrow_drop_down
      </span>
      <!-- <span v-if="active" class="icon icon-drop material-icons">arrow_drop_up</span> -->

      <Transition name="fade-up">
        <div v-if="active" :style="dropdownStyleObject" class="locale-dropdown">
          <div v-for="(locale, index) in localeList" :key="index"
               :class="{current: locale.locale === $i18n.locale}"
               class="locale-dropdown-item" @click.stop="dropdownItemOnClick(locale)"
          >
            {{ locale.label }}
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { LOCALE_LIST } from '@/assets/constants/locale'

export default {
  name: 'LocaleSeletor',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    backDrop: {
      type: Boolean,
      default: true
    },
    itemOnClick: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      active: false,
      localeList: LOCALE_LIST,
      dropdownMinHeight: 360,
      dropdownMaxWidth: 368,
      dropdownStyleObject: {
        right: '0',
        bottom: '270px',
        width: '368px',
        maxHeight: '360px'
      }
    }
  },
  computed: {
    isActive() {
      return { active: !this.disabled && this.active }
    },
    currentLocaleName() {
      const currentLocale = this.localeList.find(localeItem => localeItem.locale === this.$i18n.locale)
      return currentLocale ? currentLocale.label : ''
    }
  },
  mounted() {
  },
  methods: {
    dropdownOnClick() {
      this.dropdownStyleObject = {}
      // Dynamic set dropdwon position
      const offsetFromTop =
        this.$refs.localeBtn.getBoundingClientRect().top - window.document.body.getBoundingClientRect().top
      if (offsetFromTop > this.dropdownMinHeight) {
        const newWidth =
          this.$refs.localeBtn.getBoundingClientRect().right - this.$refs.localeBtn.getBoundingClientRect().left
        this.dropdownStyleObject.right = '0'
        this.dropdownStyleObject.width = `${newWidth}px`
        this.dropdownStyleObject.bottom = '80px'
      } else {
        // show positon on bottom
        const newWidth =
          this.$refs.localeBtn.getBoundingClientRect().right - this.$refs.localeBtn.getBoundingClientRect().left
        this.dropdownStyleObject.right = '0'
        this.dropdownStyleObject.width = `${newWidth}px`
        this.dropdownStyleObject.bottom = '-270px'
      }
      this.active = !this.active
    },
    backdropOnClick() {
      this.active = false
    },
    dropdownItemOnClick(newLocale) {
      this.$router.push({ params: { locale: newLocale.countryCode } })
      this.active = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.locale-backdrop {
  z-index: 70;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.85);
  overflow-y: hidden;
}
.locale-dropdown {
  z-index: 71;
  display: inline-block;
  position: absolute;
  // right: 36px;
  // bottom: 270px;
  // width: 368px;
  // max-height: 360px;
  border-radius: 8px;
  background-color:white;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
  overflow-x: hidden;
  overflow-y: hidden;
  // overflow-y: scroll;
  &-item {
    width: 100%;
    height: 56px;
    padding: 0 24px;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    line-height: 56px;
    color: $grey-7d;
    border-bottom: solid 1px $grey-ec;
    text-align: left;
    cursor: pointer;
  }
  &-item.current {
    font-weight: 700;
    color: $grey-50;
  }
}
.locale-btn {
  z-index: 71;
  display: inline-block;
  position: relative;
  width: 270px;
  height: 56px;
  margin-bottom: 24px;

  color: $theme-red;
  border: 1px solid $theme-red;
  border-radius: 36px;
  background-color: white;
  transition: color 0.4s, border-color 0.4s, background-color 0.4s;
  outline: none;
  cursor: pointer;
  .icon {
    font-size: 24px;
    line-height: 56px;
  }
  .icon-map {
    position: absolute;
    top: 0;
    left: 18px;
    padding-right: 16px;
  }
  .icon-map:after {
    content: ' ';
    position: absolute;
    border-right: 1px solid $grey-ec;
    top: 8px;
    left: 40px;
    height: 40px;
  }
  .icon-drop {
    position: absolute;
    top: 0;
    right: 22px;
    // padding-left: 16px;
    transform-origin: center;
    transition: transform 0.4s ease;
  }
  .separator {
    position: absolute;
    top: 0;
    left: 4px;
    width: 1px;
  }
  .label {
    position: absolute;
    top: 0;
    left: 60px;
    width: calc((100% - 56px) - 56px);
    padding: 0 16px;
    color: $grey-50;
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    line-height: 56px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.locale-btn.active,
.locale-btn:hover.active {
  color: $grey-9b;
  border: 1px solid $grey-9b;
  .icon-drop {
    transform: rotate(180deg);
  }
}

.locale-btn:disabled,
.locale-btn:disabled:hover {
  color: $grey-9b;
  border-color:  $grey-f3;
  background-color: $grey-f3;
  cursor: not-allowed;
}

.locale-btn:hover {
  color: $theme-red-hover;
  border-color: $theme-red-hover;
}

.locale-btn:active {
  color: $theme-red-active;
  border-color: $theme-red-active;
}

@media only screen and (min-width: 1440px) {
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}

@media only screen and (max-width: 767.98px) {
  .locale-btn {
    width: 100%;
    .label {
      text-align: center;
    }
  }
}
</style>
